import {
  EnumConfirmationCodeType,
  useUserCreateConfirmationCodeMutation,
  useUserResendConfirmationCodeMutation,
  useUserValidateConfirmationCodeMutation,
} from "gql/generated";
import { useState } from "react";

export const useSendOneTimeCode = () => {
  const [createConfirmationCode] = useUserCreateConfirmationCodeMutation();
  const [validateConfirmationCode, { loading: validating }] =
    useUserValidateConfirmationCodeMutation();
  const [resendConfirmationCode, { loading: resendLoading }] =
    useUserResendConfirmationCodeMutation();

  const [codeStatus, setCodeStatus] = useState<"neutral" | "invalid" | "valid">(
    "neutral",
  );

  const handleSendOneTimeCodeToUser = async (userId: string, email: string) => {
    // Run the mutation but pass any errors back up to the caller
    await createConfirmationCode({
      variables: {
        id: userId,
        email,
        confirmationCodeType:
          EnumConfirmationCodeType.OperatorOwnershipConfirmation,
      },
    });
  };

  const handleValidateConfirmationCode = (userId: string, code: string) => {
    validateConfirmationCode({ variables: { id: userId, code } })
      .then(() => {
        setCodeStatus("valid");
      })
      .catch(() => {
        setCodeStatus("invalid");
      });
  };

  const handleResendConfirmationCode = async (
    userId: string,
    email: string,
  ) => {
    // Run the mutation but pass any errors back up to the caller
    await resendConfirmationCode({
      variables: {
        id: userId,
        sentToEmail: email,
        type: EnumConfirmationCodeType.OperatorOwnershipConfirmation,
      },
    });
  };

  const resetStatus = () => {
    setCodeStatus("neutral");
  };

  return {
    onSendOneTimeCodeToUser: handleSendOneTimeCodeToUser,
    onValidateConfirmationCode: handleValidateConfirmationCode,
    onResendConfirmationCode: handleResendConfirmationCode,
    codeStatus,
    resendLoading,
    resetStatus,
    validating,
  };
};
